import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
import VueGtag from "vue-gtag";
import { i18n } from "../plugins/i18n.js";

Vue.use(VueRouter);
// * Views
const Login = () => import("../views/page_login.vue");
const Default = () => import("../views/Default_View.vue");
const Account = () => import("../views/page_account.vue");
const AccountDetail = () => import("../views/page_accountDetail.vue");
const Profile = () => import("../views/page_profile.vue");
const Disbursement = () => import("../views/page_disbursement.vue");
const ImportEtax = () => import("../views/page_importEtax.vue");
const ImportEtaxFile = () => import("../views/page_importEtaxFile.vue");
const ConsiderLoan = () => import("../views/page_considerLoan.vue");
const ImportExcel = () => import("../views/page_importExcel.vue");
const ImportOnline = () => import("../views/page_importOnline.vue");
const Status = () => import("../views/page_status.vue");
const StatusDetail = () => import("../views/page_statusGetListInGroup.vue");
const DebitStatusDetail = () => import("../views/page_getDebitInGroup.vue");
const RejectHistory = () => import("../views/page_rejectHistory.vue");
const Report = () => import("../views/page_report.vue");
const ReportCancel = () => import("../views/page_report_cancel.vue");
const ReportReject = () => import("../views/page_report_reject.vue");
const RestrictedArea = () => import("../views/page_403.vue");
const Dashboard = () => import("../views/page_dashboard.vue");
const Logout = () => import("../views/page_logout.vue");
const EditContractBuyer = () => import("../views/page_editContractBuyer.vue");
const IncreaseDecrease = () => import("../views/page_IncreaseDecrease.vue");
const Notification = () => import("../views/page_notification.vue");
const Setting = () => import("../views/page_settings.vue");
const RequestORG = () => import("../views/page_requestorg.vue");
// * Function

let beforePath = "";

const logout = (to, from, next) => {
  store.dispatch("logout_service").then((res) => {
    console.log(res);
    if (process.env.NODE_ENV === "development") {
      next("/login");
    } else {
      location.assign(
        process.env.VUE_APP_URL_ONEID +
          "/api/oauth/logout?redirect_url=" +
          process.env.VUE_APP_URL_LANDINGPAGE
      );
    }
  });
};

const ifAuthenticated = (to, from, next) => {
  if (
    Vue.$cookies.isKey("seller_authorize") === true &&
    Vue.$cookies.get("seller_authorize") === "true" &&
    Vue.$cookies.isKey("seller_accesstoken") === true
  ) {
    console.log(store.getters.gettersProfileActive.type);
    if (store.getters.gettersAuthorize === true) {
      if (
        to.meta.access.includes(store.getters.gettersProfileActive.type) ===
        true
      ) {
        next();
      } else {
        next("/403");
      }
    } else {
      next("/authentication");
    }
    return;
  } else {
    console.log("to", to);
    if ("id" in to.query) {
      next({
        path: "/loginefactoring",
        query: { redirect: to.path, taxid: to.query.id },
      });
    } else {
      next("/authentication");
    }
  }
  // else {
  //   //
  //   store
  //     .dispatch("checking_authorize")
  //     .then((res) => {
  //       if (res.status === "OK") {
  //         if (to.meta.access.includes(store.getters.gettersProfileActive.type) === true) {
  //           next();
  //         } else {
  //           next("/403");
  //         }
  //       } else {
  //         next("/authentication");
  //       }
  //     })
  //     .catch((ex) => {
  //       next("/authentication");
  //     });
  //   return;
  // }
};

const ifAuthenticatedSuperAdmin = (to, from, next) => {
  if (
    Vue.$cookies.isKey("seller_authorize") === true &&
    Vue.$cookies.get("seller_authorize") === "true" &&
    Vue.$cookies.isKey("seller_accesstoken") === true
  ) {
    console.log(store.getters.gettersProfileActive.type);
    if (store.getters.gettersAuthorize === true) {
      if (
        to.meta.access.includes(store.getters.gettersProfileActive.type) ===
          true &&
        store.getters.gettersProfileActive.status_superAdmin === "true"
      ) {
        next();
      } else {
        next("/403");
      }
    } else {
      next("/authentication");
    }
    return;
  } else {
    //
    store
      .dispatch("checking_authorize")
      .then((res) => {
        if (res.status === "OK") {
          if (
            to.meta.access.includes(store.getters.gettersProfileActive.type) ===
              true &&
            store.getters.gettersProfileActive.status_superAdmin === "true"
          ) {
            next();
          } else {
            next("/403");
          }
        } else {
          next("/authentication");
        }
      })
      .catch((ex) => {
        next("/authentication");
      });
    return;
  }
};

const ifAuthenticatedHomePage = (to, from, next) => {
  if (
    Vue.$cookies.isKey("seller_authorize") === true &&
    Vue.$cookies.get("seller_authorize") === "true" &&
    Vue.$cookies.isKey("seller_accesstoken") === true
  ) {
    console.log(store.getters.gettersProfileActive.type);
    // if (store.getters.gettersProfileActive.type === "business") {
    //   console.log();
    //   next("/dashboard");
    // } else {
    //   next("/profile");
    // }
    // console.log(beforePath, "beforePath if");
    next("/profile");
    return;
  } else {
    //
    store
      .dispatch("checking_authorize")
      .then((res) => {
        if (res.status === "OK") {
          // console.log(beforePath, "beforePath else");
          next("/profile");
        } else {
          next("/authentication");
        }
      })
      .catch((ex) => {
        next("/authentication");
      });
    return;
  }
};
// Function ไปหน้า Login ของ One ID
const loginsso = (to, from, next) => {
  window.location.assign(process.env.VUE_APP_API_ONEID_SSO);
};

// * Route
const routes = [
  {
    path: "/",
    name: "Home",
    component: Login,
    beforeEnter: ifAuthenticatedHomePage,
  },
  {
    path: "/loginbyaccesstoken",
    name: "Login-accesstoken",
    component: () => import("../views/page_loginAccessToken.vue"),
  },
  {
    path: "/test",
    name: "Home",
    component: () => import("../views/page_test.vue"),
  },
  {
    path: "/loginefactoring",
    name: "Login-eFactoring",
    component: () => import("../views/page_loginefactoring.vue"),
    meta: { title: "Login e-Factoring | Digital Factoring Platform" },
  },
  {
    path: "/logininet",
    name: "Login-inet",
    component: () => import("../views/page_loginInet.vue"),
    meta: { title: "Login e-Factoring | Digital Factoring Platform" },
  },
  {
    path: "/authentication",
    name: "page_authentication",
    // beforeEnter: loginsso,
    redirect: "/loginefactoring",
    meta: { title: "Authentication | Digital Factoring Platform" },
  },
  {
    path: "/403",
    name: "page_403",
    component: RestrictedArea,
    meta: { title: "403 Forbitden | Digital Factoring Platform" },
  },
  {
    path: "/default",
    name: "DefaultPage",
    component: Default,
    meta: {
      title: "My Profile | Digital Factoring Platform",
      access: ["citizen", "business"],
    },
  },
  {
    path: "/login",
    name: "page_login",
    component: Login,
    meta: { title: "Login | Digital Factoring Platform", metaTags: [] },
  },
  {
    path: "/logout",
    name: "page_logout",
    component: Logout,
    meta: { title: "Logout | Digital Factoring Platform", metaTags: [] },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Account | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/account",
    name: "Account",
    component: Account,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Account | Digital Factoring Platform",
      access: ["business"],
    },
  },
  // {
  //   path: "/account/:id",
  //   name: "AccountDetail",
  //   component: AccountDetail,
  //   meta: { title: "Account Detail | eFactoring", access: ["business"] },
  // },
  {
    path: "/buyer",
    name: "Buyer",
    component: () => import("../views/page_buyer.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Buyer | Digital Factoring Platform", access: ["business"] },
  },
  {
    path: "/account_detail",
    name: "AccountDetail",
    component: AccountDetail,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Account Detail | Digital Factoring Platform",
      access: ["business"],
    },
  },
  // {
  //   path: "/add_buyer",
  //   name: "AddBuyer",
  //   component: AddContractBuyer,
  //   beforeEnter: ifAuthenticated,
  //   meta: { title: "Add Buyer Contract | Digital Factoring Platform", access: ["business"] },
  // },
  {
    path: "/add_buyerv2",
    name: "AddBuyer",
    component: () => import("../views/page_addContractBuyerV2.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Add Buyer Contract | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/edit_buyer",
    name: "EditBuyer",
    component: EditContractBuyer,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Edit Buyer Contract | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/profile",
    name: "page_profile",
    component: Profile,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "My Profile | Digital Factoring Platform",
      access: ["citizen", "business"],
    },
  },
  {
    path: "/disbursement",
    name: "Disbursement",
    component: Disbursement,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Disbursement | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/importetax",
    name: "importEtax",
    component: ImportEtax,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Import Invoices by Etax | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/considerloan",
    name: "considerloan",
    component: ConsiderLoan,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Consider Loan | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/importetaxfile",
    name: "importEtaxFile",
    component: ImportEtaxFile,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Import Invoices by Etax(PDF/XML) | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/importexcel",
    name: "ImportExcel",
    component: ImportExcel,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Import Invoices by Excel| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/importonline",
    name: "ImportOnline",
    component: ImportOnline,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Import Invoices Online| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/status",
    name: "Status",
    component: Status,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Status | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/status_detail",
    name: "StatusDetail",
    component: StatusDetail,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Status Detail | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/debit_status_detail",
    name: "DebitStatusDetail",
    component: DebitStatusDetail,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Status Detail | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/increase_decrease_deft",
    name: "IncreaseDecrease",
    component: IncreaseDecrease,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Increase/Decrease Deft | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/increase_decrease_etax",
    name: "IncreaseDecreaseEtax",
    component: () => import("../views/page_IncreaseDecreaseEtax.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Increase/Decrease Deft | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/reject-history",
    name: "Reject History",
    component: RejectHistory,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Reject History | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/report",
    name: "Report",
    component: Report,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Report | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/reportCancel",
    name: "Report Cancel",
    component: ReportCancel,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Report Cancel | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/reportReject",
    name: "Report Reject",
    component: ReportReject,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Report Reject | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/approve-invoice",
    name: "approve-invoice",
    component: () => import("../views/page_approveInvoice.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Approve Invoice | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/settings",
    name: "Setting",
    component: Setting,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Setting | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/notification",
    name: "notification",
    component: Notification,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Notification | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/settingca",
    name: "settingca",
    component: () => import("../views/page_settingCA.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Setting CA | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/registerca",
    name: "RegisterCA",
    component: () => import("../views/page_registerca.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "CA Register | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/managecad",
    name: "ManageCAD",
    component: () => import("../views/page_manageCAD.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "CAD Management | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/requestorg",
    name: "RequestORG",
    component: RequestORG,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Request to ORG | Digital Factoring Platform",
      access: ["citizen"],
    },
  },
  {
    path: "/webview-dashboard",
    name: "WebviewDashboard",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/webview-dashboard.vue"),
    // beforeEnter: ifAuthenticated,
    meta: {
      title: "Webview | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/webview-contracts",
    name: "WebviewContact",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/webview-contracts.vue"),
    // beforeEnter: ifAuthenticated,
    meta: {
      title: "Webview | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/webview-invoices",
    name: "WebviewInvoices",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/webview-invoices.vue"),
    // beforeEnter: ifAuthenticated,
    meta: {
      title: "Webview | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/webview-request_to_org",
    name: "WebviewRequestToORG",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/webview-request_to_org.vue"
      ),
    // beforeEnter: ifAuthenticated,
    meta: {
      title: "Webview | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/webview-verify_invoices",
    name: "WebViewVerifyInvoice",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/webview_verify.vue"),
    // beforeEnter: ifAuthenticated,
    meta: {
      title: "Webview | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/admin-role-permission",
    name: "AdminRolePermission",
    component: () => import("../views/page_adminRolePermission.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Role Permission| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-role-permission-setting",
    name: "AdminRolePermissionSetting",
    component: () => import("../views/page_adminRolePermissionSetting.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Role Permission Setting| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-add-role",
    name: "AdminAddRole",
    component: () => import("../views/page_adminAddRole.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Add Role | Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-role-setting",
    name: "AdminRoleSetting",
    component: () => import("../views/page_adminRoleSetting.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Role Setting| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-log",
    name: "Admin-log",
    component: () => import("../views/page_adminLog.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Log| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-settings",
    name: "AdminSetting",
    component: () => import("../views/page_adminSettings.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Setting| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-notification",
    name: "AdminNotification",
    component: () => import("../views/page_adminNotification.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Notification| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/admin-update",
    name: "AdminUpdate",
    component: () => import("../views/page_adminUpdate.vue"),
    beforeEnter: ifAuthenticatedSuperAdmin,
    meta: {
      title: "Admin Update| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: () => import("../views/page_feedback.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Feedback| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/etax",
    name: "etax",
    component: () => import("../views/etax_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "e-Tax Invoice & e-Receipt| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/billing-rpt",
    name: "billing-rpt",
    component: () => import("../views/page_billingRPT.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Billing RPT| Digital Factoring Platform",
      access: ["business"],
    },
  },
  {
    path: "/overdue",
    name: "overdue",
    component: () => import("../views/page_invoice_overdue.vue"),
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Invoice Overdue| Digital Factoring Platform",
      access: ["business"],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  duplicateNavigationPolicy: "ignore",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

//? Enable Google Analytics
Vue.use(
  VueGtag,
  {
    config: {
      enabled: process.env.NODE_ENV === "production",
      // enabled: true,
      id: process.env.VUE_APP_GTAG_ID,
    },
    appName: process.env.VUE_APP_GTAG_APPNAME,
    pageTrackerScreenviewEnabled: true,
  },
  router
);

const DEFAULT_TITLE = "Seller | eFactoring Platform";

router.beforeEach((to, from, next) => {
  if (
    localStorage.getItem("lang") &&
    localStorage.getItem("lang") !== i18n.locale
  ) {
    i18n.locale = localStorage.getItem("lang");
  } else if (!localStorage.getItem("lang")) {
    localStorage.setItem("lang", "th");
    i18n.locale = localStorage.getItem("lang");
  }
  next();
});
router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
